import { RouteInfo } from "./types";
import { authGuard, permissionGuard } from "./guards/index";
import { UIPAGE } from "@/constants/ui-page.constants";
import { ColorStatusType } from "@/constants/colors.constants";

const ViewTrackingCustomersAggrupations = () =>
	import(/* webpackChunkName: "chunk-tracking-customers-aggrupations" */ "@/views/tracking-customers-aggrupations/TrackingCustomersAggrupations.vue");

export const TrackingCustomersAggrupationsRoute: RouteInfo = {
	id: UIPAGE.TRACKING_CUSTOMERS_AGGRUPATIONS,
	path: "/aggrupations",
	component: ViewTrackingCustomersAggrupations,
	guards: [authGuard, permissionGuard],
	title: "customers.customer_360.aggrupations.display",
	icon: "mdi-draw-pen",
	iconColor: ColorStatusType.ORANGE_LIGHT
};
